import { AppliesProvider } from 'Context/AppliesContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { CustomMetaTitle } from 'Components';
import { AppliesLobbyMain } from './AppliesLobbyMain';

export const AppliesLobby = () => {
  return (
    <AppliesProvider>
      <CustomMetaTitle title={Dictionary[DICTIONARY.Applies].yourRequests} />
      <AppliesLobbyMain />
    </AppliesProvider>
  );
};
